export default "__VITE_PUBLIC_ASSET__f198e30c__"